import { currencyRateConversion } from "../../../../utils/hooks/dataHandler";
import { createExchangeRateResolver } from "../shared";

export const getUnabsorbedSummaryAllocation = (row) => {
  const balanceAvailable = Math.abs(parseFloat(row?.amount) || 0);
  const rawBalanceCf = parseFloat(row?.balanceCf);
  const hasUtilisation =
    row?.utilisedThisYear !== null &&
    row?.utilisedThisYear !== undefined &&
    row?.utilisedThisYear !== "";
  const requestedUtilisation = hasUtilisation
    ? Math.abs(parseFloat(row.utilisedThisYear) || 0)
    : Number.isFinite(rawBalanceCf)
      ? Math.max(0, balanceAvailable - Math.abs(rawBalanceCf))
      : 0;
  const currentYearUtilisation = Math.min(balanceAvailable, requestedUtilisation);

  return {
    balanceAvailable,
    currentYearUtilisation,
    balanceCf: balanceAvailable - currentYearUtilisation,
  };
};

export const allocateIrasUnabsorbedSgdAmounts = ({ rows, currencyRate, summary }) => {
  const getExchangeRate = createExchangeRateResolver(currencyRate);
  const allocations = rows.map((row) => {
    const local = getUnabsorbedSummaryAllocation(row);
    const rate = getExchangeRate(row.exchangeRate);
    const convert = (amount) => Math.round(currencyRateConversion(amount, rate, "SGD"));
    const balanceAvailable = summary && !row.isForfeited
      ? Math.abs(convert(-local.balanceAvailable))
      : convert(local.balanceAvailable);
    const balanceCf = convert(local.balanceCf);
    return { balanceAvailable, balanceCf };
  });
  if (!summary) return allocations;

  const activeIndices = rows.flatMap((row, index) => row.isForfeited ? [] : [index]);
  if (activeIndices.length === 0) return allocations;
  const totalAvailable = activeIndices.reduce(
    (total, index) => total + allocations[index].balanceAvailable, 0
  );
  let adjustment = summary.balanceAvailable - totalAvailable;
  // Grouped current-year balances must retain the main table's row rounding.
  const currentLossIndex = activeIndices.find((index) => rows[index].currentYearLossesAmount > 0);
  const adjustmentIndex = currentLossIndex ?? activeIndices[activeIndices.length - 1];
  const adjustmentOrder = [adjustmentIndex, ...activeIndices.filter((index) => index !== adjustmentIndex).reverse()];
  for (const index of adjustmentOrder) {
    const applied = Math.max(-allocations[index].balanceAvailable, adjustment);
    allocations[index].balanceAvailable += applied;
    adjustment -= applied;
    if (adjustment === 0) break;
  }

  // Allocate the main computation's SGD utilisation in the same year order.
  // Converting the local utilisation or c/f again would introduce rounding drift.
  let remainingUtilisation = Math.max(0, summary.balanceAvailable - summary.balanceCf);
  activeIndices.forEach((index) => {
    const allocation = allocations[index];
    const utilised = Math.min(allocation.balanceAvailable, remainingUtilisation);
    allocation.balanceCf = allocation.balanceAvailable - utilised;
    remainingUtilisation -= utilised;
  });
  return allocations;
};
